import React from 'react';
import {withRouter} from 'react-router';

import AssignmentsFoldersWrapper from 'client/components/AssignmentsFolders/AssignmentsFoldersWrapper.react';
import {useHasTeacherDashboard} from 'client/components/FeatureFlag/useHasTeacherDashboard';

import {DashboardHeader} from './DashboardHeader';
import {TeacherDashboardLayout} from './TeacherDashboardLayout';

interface Props {
  children: React.ReactNode;
  router: {location: {pathname?: string}};
}

/**
 * Chrome for the cross-class classwork routes (Assignments, Folders, Diagnostics).
 * Flag-on teachers get the v2 dashboard shell with the scope-aware header; everyone
 * else keeps the legacy assignments/folders sidebar.
 */
const ClassworkChrome = ({children, router}: Props) => {
  const {hasTeacherDashboard} = useHasTeacherDashboard();

  if (hasTeacherDashboard) {
    const pathname = router.location.pathname ?? '';
    return (
      <TeacherDashboardLayout header={<DashboardHeader pathname={pathname} />} pathname={pathname}>
        {children}
      </TeacherDashboardLayout>
    );
  }

  return <AssignmentsFoldersWrapper>{children}</AssignmentsFoldersWrapper>;
};

export default withRouter(ClassworkChrome);
